import projection from '../generated/pwn201f1.json';
import { AcceptanceManifest } from '../types';
export const pwn201f1AcceptanceManifest = projection as AcceptanceManifest;
